import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys($data.modal), (item) => {
    return (_openBlock(), _createBlock(_resolveDynamicComponent($data.modal[item]), {
      ref_for: true,
      ref: item
    }, null, 512 /* NEED_PATCH */))
  }), 256 /* UNKEYED_FRAGMENT */))
}